export enum ProfileSectionStatusEnum {
    NA = 0,
    NotCreated = 1,
    Created = 2,
    Edited = 3,
}
